import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ExecuteUserDataDeletion } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const executeUserDataDeletion: ExecuteUserDataDeletion = (params) => {
  return axios.post('/meta/user-data-deletion/confirm', params);
};

type UseExecuteUserDataDeletionOptions = {
  config?: MutationConfig<typeof executeUserDataDeletion>;
};

export function useExecuteUserDataDeletion({
  config = {},
}: UseExecuteUserDataDeletionOptions = {}) {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      toasts.loadingToast.success('execute-user-data-deletion', 'Users data removed successfully');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('execute-user-data-deletion', serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: executeUserDataDeletion,
  });
}
